import React, { useState } from "react";
import { Pressable } from "react-native";

import {
  ChevronMiniFullDownIcon,
  ChevronMiniFullUpIcon,
} from "../../../icons_v2/general";
import { Menu } from "../../../overlay/Menu";
import { HStack, Text } from "../../../primitive";
import { CountryCode } from "../utils/countryCodes";
import { VirtualizedCountryCodeList } from "./VirtualizedCountryCodeList";

type CountryCodeSelectorProps = {
  isDisabled?: boolean;
  countryCode: CountryCode;
  setCountryCode: (countryCode: CountryCode) => void;
  countryCodes: CountryCode[];
  variant?: "default" | "subtle";
};

export const CountryCodeSelector = ({
  countryCode,
  isDisabled,
  setCountryCode,
  countryCodes,
  variant = "default",
}: CountryCodeSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCountryCodePress = (countryCode: CountryCode) => {
    setIsOpen(false);
    setCountryCode(countryCode);
  };

  return (
    <Menu
      overrideIsOpen={isOpen}
      onClose={() => setIsOpen(false)}
      trigger={(triggerProps) => {
        return (
          <Pressable
            {...triggerProps}
            onPress={() =>
              !isDisabled && countryCodes.length > 1 && setIsOpen(true)
            }
            style={{
              marginLeft: 16,
            }}
          >
            <HStack alignItems="center" gap={2}>
              {countryCode.icon}
              {countryCodes.length > 1 ? (
                isOpen ? (
                  <ChevronMiniFullUpIcon color="text-secondary" />
                ) : (
                  <ChevronMiniFullDownIcon color="text-secondary" />
                )
              ) : null}

              <Text
                color="text-secondary"
                variant={
                  // Match the Input's 13px semibold so the code lines up with the number
                  variant === "subtle" ? "mainHeading" : "mainSmallSemiBold"
                }
              >
                +{countryCode.code}
              </Text>
            </HStack>
          </Pressable>
        );
      }}
      content={() => (
        <Menu.Content>
          <VirtualizedCountryCodeList
            countryCodes={countryCodes}
            selectedCountryCode={countryCode}
            onCountryCodePress={handleCountryCodePress}
          />
        </Menu.Content>
      )}
    />
  );
};
